export default "immagini/logo-unahotels-bianco.svg"